var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import styled, { css } from "styled-components";
import * as typography from "../../typography";
import { bonfireGet } from "../../theme";
import { attachProps } from "../../utils";
function textAsElement(element) {
    return function (props) { return (React.createElement(Text, __assign({ as: element }, props))); };
}
var defaultVariantElements = {
    titleXL: "div",
    titleL: "div",
    titleM: "div",
    title: "div",
    appName: "div",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    body: "span",
    bodyS: "span",
    subtitle: "div",
    subtitleS: "div",
    button: "span",
    legend: "legend",
    label: "label",
    avatar: "span",
    overline: "span",
    caption: "span",
    tooltip: "div"
};
var textColors = {
    dark: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), bonfireGet("colors", "textDark")),
    light: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), bonfireGet("colors", "textLight")),
    validationSuccess: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), bonfireGet("colors", "validationSuccess")),
    validationWarning: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), bonfireGet("colors", "validationWarning")),
    validationDanger: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), bonfireGet("colors", "validationDanger")),
    inherit: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: inherit;\n  "], ["\n    color: inherit;\n  "])))
};
var StyledText = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), function (props) { return typography[props.variant] || typography.body; }, function (props) { return textColors[props.color] || textColors.dark; });
/** @component */
var Text = React.forwardRef(function (_a, ref) {
    var propAs = _a.as, variant = _a.variant, children = _a.children, remainder = __rest(_a, ["as", "variant", "children"]);
    return (React.createElement(StyledText
    // We can change our core type, so we cannot type to
    //  HTMLSpanElement as StyledComponents wants.
    , __assign({ 
        // We can change our core type, so we cannot type to
        //  HTMLSpanElement as StyledComponents wants.
        ref: ref, as: propAs || defaultVariantElements[variant], variant: variant }, remainder), children));
});
Text.defaultProps = {
    variant: "body",
    color: "dark"
};
export default attachProps(Text, {
    asElement: textAsElement
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=Text.js.map